<template>
  <div class="is-main-content">
    <div class="columns is-fullheight">
      <b-collapse class="is-pulled-left is-sidebar-menu" :open="isOpen"
                  v-bind:class="{'isCloseSidebar': !isOpen}">
        <aside class="menu">
          <app-filter/>
        </aside>
      </b-collapse>
      <a class="button collapse_btn" @click="isOpen = !isOpen">
        <b-icon class="icon_collapse"
                :icon="isOpen ? 'chevron-left' : 'chevron-right'">
        </b-icon>
      </a>
      <div class="column">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="">Vente Unitaire Numérique</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <div class="is-pulled-right">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="showPanneauxSelectionne"
                  @input="checkboxFiltres()">
                  Panneaux sélectionnés
                </b-checkbox>
              </div>
              <div class="is-pulled-right client">
                <app-client :disabled="true"/>
              </div>
            </div>
            <div class="positionBntExport">
              <app-export-excel v-if="indexTab === 1" :liste="dataListe"/>
            </div>
            <div class="positionAzimut">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="afficherAzimut"
                  @input="checkboxAzimut()">
                  Azimut
                </b-checkbox>
              </div>
             </div>
            <b-tabs type="is-toggle" v-model="indexTab" @input="autoZoom($event)">
              <b-tab-item :label="carteLibelle" icon="google-maps" id="ongletCarto">
                <app-carte v-if="showPanneaux && indexTab===0"
                ref="carto"/>
              </b-tab-item>
              <b-tab-item :label="listeLibelle" icon="format-list-bulleted">
                <app-liste v-on:liste="chargeListe($event)" v-if="showPanneaux"/>
              </b-tab-item>
              <b-tab-item :label="planningLibelle" icon="calendar-text">
                <app-planning v-if="showPanneaux"/>
              </b-tab-item>
            </b-tabs>
            <div v-if="!showPanneaux">
              <div>
                <div class="hero">
                  <div class="section">
                    <div class="hero-body">
                      <h1 class="title is-1 has-text-centered">Commencer votre recherche</h1>
                      <div class="content">
                        <h3 class="has-text-centered">
                          Utilisez les filtres à gauche de l'écran pour effectuer votre recherche.
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import * as typesUser from '@/store/modules/user-mutation-type';
import * as sizesGetter from '@/services/general/sizeScreenGetter';
import ExportExcel from '@/components/creationOpportunite/exportExcel';
import Filter from './filtres/filtre';
import client from '../panier/client/client';
import Carte from './recherche/carte';
import Liste from './recherche/liste';
import Planning from './recherche/planning';

const Numerique = createNamespacedHelpers('venteNumerique');
const User = createNamespacedHelpers('user');
const VALEUR_FILTRE_SELECTED = 'selected';

export default {
  name: 'index',
  data() {
    return {
      isOpen: true,
      valid: false,
      dataListe: [],
      indexTab: 0,
    };
  },
  components: {
    appFilter: Filter,
    appClient: client,
    appListe: Liste,
    appCarte: Carte,
    appPlanning: Planning,
    appExportExcel: ExportExcel,
  },
  computed: {
    ...Numerique.mapGetters({
      showPanneaux: 'showPanneaux',
      getShowPanneauxSelectionne: 'showPanneauxSelectionne',
      address: 'address',
      rayon: 'rayon',
    }),
    ...User.mapGetters({
      getAfficherAzimut: 'afficherAzimut',
    }),
    showPanneauxSelectionne: {
      get() {
        return this.getShowPanneauxSelectionne;
      },
      set(value) {
        this.setShowPanneauxSelectionne(value);
      },
    },
    afficherAzimut: {
      get() {
        return this.getAfficherAzimut;
      },
      set(value) {
        this.setAfficherAzimut(value);
      },
    },
    carteLibelle() {
      return sizesGetter.isTablet() ? '' : 'Carte';
    },
    listeLibelle() {
      return sizesGetter.isTablet() ? '' : 'Liste';
    },
    planningLibelle() {
      return sizesGetter.isTablet() ? '' : 'Planning';
    },
  },
  methods: {
    ...Numerique.mapActions({
      actionsRecuperationPanneaux: 'recuperationPanneaux',
      actionsGestionFiltres: 'gestionFiltres',
      actionsUpdateMarkerPanneau: 'updateMarkerPanneau',
    }),
    ...User.mapMutations({
      setAfficherAzimut: typesUser.SET_AZIMUT,
    }),
    ...Numerique.mapMutations({
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
      setShowPanneauxSelectionne: types.SET_SHOW_PANNEAUX_SELECTIONNE,
      trierPanneaux: types.TRIE_PANNEAUX,
      setShowPanneaux: types.SET_SHOW_PANNEAUX,
      setPointsAddress: types.SET_POINTS_ADDRESS,
      setAdress: types.SET_FILTER_ADDRESS,
    }),
    checkboxFiltres() {
      const valeursFilter = [];
      if (this.showPanneauxSelectionne) {
        valeursFilter.push(this.showPanneauxSelectionne);
      } else {
        valeursFilter.splice(this.showPanneauxSelectionne, 1);
      }
      this.setAddFilterProperty(
        { property: VALEUR_FILTRE_SELECTED,
          valueProperty: { variable: VALEUR_FILTRE_SELECTED, valeur: valeursFilter } });
      this.actionsGestionFiltres();
      this.trierPanneaux();
    },
    checkboxAzimut() {
      this.actionsUpdateMarkerPanneau();
    },
    chargeListe(data) {
      this.dataListe = data;
    },
    changeTab(i) {
      this.indexTab = i;
    },
    autoZoom(numIndexTab) {
      if (this.$refs.carto && numIndexTab === 0) {
        this.$refs.carto.autoZoom();
      }
    },
  },
  mounted() {
    if (this.address && this.rayon) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRecuperationPanneaux({ address: this.address,
        rayon: this.rayon,
        valid: true,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la récupération des panneaux numériques', e);
      });
    }
  },
  destroyed() {
    this.setPointsAddress([]);
    this.setAdress(null);
    this.setShowPanneaux(false);
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/index.vue